export const inputCls =
  "w-full rounded-lg border border-zinc-800 bg-zinc-900/60 px-3.5 h-11 text-sm text-zinc-100 placeholder:text-zinc-600 outline-none focus:border-blue-500/60 transition-colors";
export const areaCls = `${inputCls} min-h-[96px] py-3 resize-y`;
export const labelCls = "mb-1.5 block font-mono text-[11px] uppercase tracking-wider text-zinc-500";

export function Field({ label, children, className = "" }) {
  return (
    <div className={className}>
      <label className={labelCls}>{label}</label>
      {children}
    </div>
  );
}

export function Card({ title, children, actions }) {
  return (
    <div className="rounded-2xl border border-[#27272A] bg-[#121215] p-5 sm:p-6">
      <div className="mb-4 flex items-center justify-between gap-3">
        <h3 className="font-display text-base font-semibold text-zinc-100">{title}</h3>
        {actions}
      </div>
      <div className="flex flex-col gap-4">{children}</div>
    </div>
  );
}

export function SaveButton({ onClick, saving, saved, testid }) {
  return (
    <button
      data-testid={testid || "admin-save-button"}
      type="button"
      onClick={onClick}
      disabled={saving}
      className="inline-flex h-11 items-center justify-center gap-2 rounded-full bg-blue-600 px-6 text-sm font-semibold text-white hover:bg-blue-500 transition-colors disabled:opacity-60"
    >
      {saving ? (
        <>
          <span className="h-4 w-4 animate-spin rounded-full border-2 border-white/30 border-t-white" />
          Speichern …
        </>
      ) : saved ? (
        "Gespeichert!"
      ) : (
        "Speichern"
      )}
    </button>
  );
}

export function GhostButton({ onClick, children, testid, danger = false }) {
  return (
    <button
      data-testid={testid}
      type="button"
      onClick={onClick}
      className={`inline-flex h-10 items-center gap-1.5 rounded-full border px-4 text-sm font-semibold transition-colors ${
        danger
          ? "border-rose-500/40 text-rose-400 hover:bg-rose-500/10"
          : "border-zinc-700 text-zinc-300 hover:border-blue-500/50 hover:text-blue-400"
      }`}
    >
      {children}
    </button>
  );
}

export function FileLabel({ children, onFile, testid }) {
  return (
    <label className="inline-flex h-10 cursor-pointer items-center gap-1.5 rounded-full border border-zinc-700 px-4 text-sm font-semibold text-zinc-300 hover:border-blue-500/50 hover:text-blue-400 transition-colors">
      {children}
      <input
        data-testid={testid}
        type="file"
        accept="image/jpeg,image/png,image/webp,image/gif"
        className="hidden"
        onChange={(e) => {
          const f = e.target.files?.[0];
          if (f) onFile(f);
          e.target.value = "";
        }}
      />
    </label>
  );
}
